import { MutationTree } from 'vuex';
import { ColorConversionState } from '@/store/types/color-conversion.state';

export const mutations: MutationTree<ColorConversionState> = {
    setDisplayingChapter(state, value) {
        state.displayingChapter = value;
    },
    setSliderHue(state, value) {
        state.sliderHue = value;
    },
    setSliderR(state, value) {
        state.sliderR = value;
    },
    setSliderG(state, value) {
        state.sliderG = value;
    },
    setSliderB(state, value) {
        state.sliderB = value;
    },
    setSliderLuminance(state, value) {
        state.sliderLuminance = value;
    },
    setNOctaves(state, value) {
        state.nOctaves = value;
    },
    setBaseHue(state, value) {
        state.baseHue = value;
    },
    setAttack(state, value) {
        state.attack = value;
    },
};

